const maskPhoneNumber = (lastTwoDigits: string) =>
  `(***)***-***${lastTwoDigits}`;

export default maskPhoneNumber;
